/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_NicknameInputs */

const vi_grower_nickname = /** @type {(inputs: Grower_NicknameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên thường gọi`)
};

/**

* @param {Grower_NicknameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_nickname = /** @type {((inputs?: Grower_NicknameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_NicknameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_nickname(inputs)
});